import { render } from "./ProCard.vue?vue&type=template&id=a3a9fc3a&scoped=true"
import script from "./ProCard.vue?vue&type=script&lang=js"
export * from "./ProCard.vue?vue&type=script&lang=js"

import "./ProCard.vue?vue&type=style&index=0&id=a3a9fc3a&lang=scss&scoped=true"

import exportComponent from "C:\\wamp64\\www\\suph-annuaire-plugin\\suph-card-pro\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3a9fc3a"]])

export default __exports__